import {
  Boxes,
  FolderOpen,
  Home,
  LayoutGrid,
  type LucideIcon,
  MessagesSquare,
  Plug,
  ScanLine,
  Settings,
  Users,
  Database,
  Languages,
  CircleDot,
} from 'lucide-react'

/**
 * Nav icon key -> lucide icon.
 *
 * The old design renders react-icons via configs/navigation-icon.config.tsx.
 * The new design is lucide-only (flow uses it in 95 files and nothing else), so
 * the same `icon` strings in configs/navigation.config.ts are mapped again here
 * rather than changing the shared config - that config feeds both designs.
 */
const ICONS: Record<string, LucideIcon> = {
  home: Home,
  products: Boxes,
  folders: FolderOpen,
  communication: MessagesSquare,
  settings: Settings,
  customers: Users,
  support: MessagesSquare,
  assets: ScanLine,
  asset_components: LayoutGrid,
  priceplans: Plug,
  // control panel (configs/adm-cp.navigation.config.ts) - note the PascalCase keys
  CpCstlnData: Database,
  CpI18n: Languages,
}

export function navIcon(key: string | undefined): LucideIcon {
  return (key && ICONS[key]) || CircleDot
}
